//cannot import the one in utils because of dependency (nx)
export const capitalizeFirstLetter = (val: string): string => {
  if (val.length === 0) {
    return val;
  }
  if (val.length === 1) {
    return val.toUpperCase();
  }
  return val.charAt(0).toUpperCase() + val.slice(1);
};
